import
  React
from 'react';

export default ({
  size = '30',
  ...props
}) => (
  <svg
    {...props}
    fill="none"
    width={size}
    height={size}
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#333333"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.4749 14.9969C27.4749 21.8866 21.8897 27.4719 14.9999 27.4719C8.11015 27.4719 2.5249 21.8866 2.5249 14.9969C2.5249 8.10713 8.11015 2.52188 14.9999 2.52188C21.8897 2.52188 27.4749 8.10713 27.4749 14.9969ZM8.66351 14.7823C9.01498 14.4308 9.58483 14.4308 9.9363 14.7823L12.7547 17.6006L19.8917 10.4636C20.2432 10.1121 20.813 10.1121 21.1645 10.4636C21.516 10.8151 21.516 11.3849 21.1645 11.7364L13.391 19.5098C13.0396 19.8613 12.4697 19.8613 12.1183 19.5098L8.66351 16.0551C8.31204 15.7036 8.31204 15.1338 8.66351 14.7823Z"
    />
    <mask
      x="2"
      y="2"
      width="26"
      height="26"
      id="maskSuccessCircle0"
      // maskType="alpha"
      maskUnits="userSpaceOnUse"
    >
      <path
        fill="white"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.4749 14.9969C27.4749 21.8866 21.8897 27.4719 14.9999 27.4719C8.11015 27.4719 2.5249 21.8866 2.5249 14.9969C2.5249 8.10713 8.11015 2.52188 14.9999 2.52188C21.8897 2.52188 27.4749 8.10713 27.4749 14.9969ZM8.66351 14.7823C9.01498 14.4308 9.58483 14.4308 9.9363 14.7823L12.7547 17.6006L19.8917 10.4636C20.2432 10.1121 20.813 10.1121 21.1645 10.4636C21.516 10.8151 21.516 11.3849 21.1645 11.7364L13.391 19.5098C13.0396 19.8613 12.4697 19.8613 12.1183 19.5098L8.66351 16.0551C8.31204 15.7036 8.31204 15.1338 8.66351 14.7823Z"
      />
    </mask>
    <g mask="url(#maskSuccessCircle0)">
      <rect
        width="30"
        height="30"
        fill="#428600"
      />
    </g>
  </svg>
);
